import React, { useEffect } from "react";

import {
  AccountOpeningFeeLoadable,
  DetailsFromKYCLoadable,
  DocumentUploadLoadable,
  ExistingClinetEmailMobileVerificationLoadable,
  LinkBankAccountLoadable,
  LivePhotoUploadLoadable,
  PLMAQuestionLoadable,
  Stage7Loadable,
  Stage8Loadable,
  StartWithPANLoadable,
  Step0Loadable,
} from "./LoadableComponents";
import { dispatch, RootState, useSelector } from "../redux/store";
import { useLocation } from "react-router";
import {
  fetchSubBrokerDetails,
  logOutAndResetFields,
  setInitialQueryParams,
} from "../redux/slices/common";
import utils from "../Services/Utils";
import { tryHistoryPush } from "./Main";
import { verifyMobileOTP } from "../redux/slices/registration";

export default function StageSelection() {
  const { stage } = useSelector((state: RootState) => state.common);
  const location = useLocation();
  useEffect(() => {
    if (location.search) {
      const objQS: any = utils.parseQueryString(location.search);

      if ((objQS.AOPRID && objQS.AOPRUID) || objQS.BPC) {
        dispatch(
          fetchSubBrokerDetails(
            parseInt(objQS.AOPRID) || 0,
            objQS.AOPRUID,
            objQS.BPC
          )
        );
      }

      if (objQS.AORID && objQS.AORUID && objQS.AIT && objQS.TTIC) {
        dispatch(verifyMobileOTP("", objQS));
      }
      if (Object.keys(objQS).length > 0) {
        dispatch(logOutAndResetFields());
        dispatch(setInitialQueryParams(objQS));
        tryHistoryPush("/");
      }
    }
  }, [location.search]);

  const renderState = () => {
    if (stage >= 0 && stage < 1) {
      return <Step0Loadable />;
    } else if (stage === 1) {
      return <StartWithPANLoadable />;
    } else if (stage === 1.1) {
      return <ExistingClinetEmailMobileVerificationLoadable />;
    } else if (stage === 2) {
      return <AccountOpeningFeeLoadable />;
    } else if (stage === 3.0) {
      return <DetailsFromKYCLoadable />;
    } else if (stage === 3.1) {
      return <PLMAQuestionLoadable />;
    } else if (stage === 4) {
      return <DocumentUploadLoadable />;
    } else if (stage === 5) {
      return <LinkBankAccountLoadable />; // DJT 31052025
    } else if (stage === 6) {
      return <Stage7Loadable />; // DJT 31052025
    } else if (stage === 7) {
      return <LivePhotoUploadLoadable />; // DJT 31052025
    } else if (stage === 8) {
      return <Stage8Loadable />;
    } else {
      return <div>Unexpected stage identified.</div>;
    }
  };
  return <div key={stage}>{renderState()}</div>;
}
